import React, { useState, useEffect } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap"
import Select from "react-select"
import { Formik } from "formik"
import * as Yup from "yup"
import axios from "axios"

const UpdateModal = ({
  syncDate,
  isOpen,
  toggle,
  selectedItem,
  mode,
  stageList,
  users,
  viewVisitsToggle,
  statusOptions,
  userPermissions
}) => {
  const isEditMode = mode === "edit"
  if (!isEditMode) {
    selectedItem = {}
  }

  const [avilableData, setAvilableData] = useState([])
  useEffect(() => {
    // isEditMode && avilableData.push(selectedItem.VisitDate)
    const formdata = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      // ID:  selectedItem.id ,
    }
    axios
      .post(
        process.env.REACT_APP_API_URL + "api/Visits/VisitData.php",
        formdata
      )
      .then(res => {

        !res.data.Dates.includes(selectedItem.VisitDate)&& res.data.Dates.push(selectedItem.VisitDate)
        setAvilableData(
          [...avilableData, ...res.data.Dates].map(date => ({
            value: date,
            label: date,
          })),

          
          
        
        )
      })
      .catch(error => {
        console.log(error)
      })
  }, [])


  
  
  const initialValues = {
    stage: isEditMode ? selectedItem.StageID : "",
    date: isEditMode ? selectedItem.VisitDate : "",
    inspector: isEditMode ? selectedItem.InspectorID : "",
    statusID: isEditMode ? selectedItem.StatusID : "",
    comment: isEditMode ? selectedItem.HoldNote : "",
    referenceNo: "",
  }

  const status = isEditMode ? [1, 4] : [0,  3]

  const cofirmeduser=   userPermissions.R1.G === "1" ||
                        userPermissions.R2.G === "1" ||
                        userPermissions.R32.P === "1" ||
                        userPermissions.R32.P === "2" ||
                        userPermissions.R32.P === "3" ||
                        userPermissions.R32.P === "4" 
   
 cofirmeduser && !isEditMode && status.push(2)
                            

  const validationSchema = Yup.object({
    stage: Yup.string().nullable().required("Stage is required"),
    date: Yup.date().required("Date is required"),
    inspector: Yup.string().nullable().required("Inspector is required"),
    statusID:
      isEditMode && Yup.string().nullable().required("State is required"),
    referenceNo:
      !isEditMode &&
      Yup.number().nullable().required("ReferenceNo is required"),
    comment: Yup.string().when("statusID", {
      is: statusID => statusID && statusID === "4",
      then: Yup.string()
        .required("Comment is required when status is Hold")
        .max(500, "Maximum 500 characters allowed"),
      otherwise: Yup.string().max(500, "Maximum 500 characters allowed"),
    }),
  })
  
  const handleSubmit = values => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ID: isEditMode ? selectedItem.id : undefined,
      ReferenceNo: !isEditMode ? values.referenceNo : undefined,
      Note: !isEditMode ? values.Note : undefined,
      InspectorID: values.inspector,
      StageID: values.stage,
      Date: values.date,
      StatusID: values.statusID,
      HoldNote: values.comment,
    }
    const url = process.env.REACT_APP_API_URL + "api/Visits/VisitCont.php"

    axios
      .post(url, formData)
      .then(res => {
        syncDate()
        toggle()

        isEditMode && viewVisitsToggle()
      })
      .catch(error => {})
  }

  statusOptions = statusOptions?.filter(option => status.includes(option.value))

  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {isEditMode ? "Edit Visit" : "Add Visit"}
        </ModalHeader>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            setFieldValue,
            handleSubmit,
          }) => (
            <Form onSubmit={handleSubmit}>
              <ModalBody>
                {!isEditMode && (
                  <FormGroup>
                    <Label for="referenceNo">ReferenceNo</Label>
                    <Input
                      id="referenceNo"
                      type="number"
                      name="referenceNo"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.referenceNo && errors.referenceNo && (
                      <div className="text-danger">{errors.referenceNo}</div>
                    )}
                  </FormGroup>
                )}
                <FormGroup>
                  <Label for="stage">Stage</Label>
                  <Select
                    id="stage"
                    options={stageList}
                    defaultValue={stageList?.find(
                      option => option.value == selectedItem?.StageID
                    )}
                    onChange={option => setFieldValue("stage", option?.value)}
                    onBlur={handleBlur("stage")}
                    isClearable
                  />
                  {touched.stage && errors.stage && (
                    <div className="text-danger">{errors.stage}</div>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label for="date">Date</Label>

                  <Select
                    id="date"
                    options={avilableData.map(option => ({
                      ...option,
                      color: option.value === selectedItem.VisitDate && "blue",
                    }))}
                    value={avilableData?.find(
                      date => date.value === values.date
                    )}
                    onChange={option => setFieldValue("date", option?.value)}
                    onBlur={handleBlur("date")}
                    isClearable
                    styles={{
                      control: provided => ({
                        ...provided,
                        borderColor:
                          touched.date && errors.date
                            ? "red"
                            : provided.borderColor,
                      }),
                      singleValue: (provided, state) => ({
                        ...provided,
                        color: state.data.color,
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        color: state.data.color,
                      }),
                    }}
                  />
                  {touched.date && errors.date && (
                    <div className="text-danger">{errors.date}</div>
                  )}
                </FormGroup>

                <FormGroup>
                  <Label for="inspector">Inspector</Label>
                  <Select
                    id="inspector"
                    options={users}
                    defaultValue={
                      users?.find(
                        option => option.value === selectedItem?.InspectorID
                      ) || ""
                    }
                    onChange={option =>
                      setFieldValue("inspector", option?.value)
                    }
                    onBlur={handleBlur("inspector")}
                    isClearable
                  />
                  {touched.inspector && errors.inspector && (
                    <div className="text-danger">{errors.inspector}</div>
                  )}
                </FormGroup>
                {
                  <FormGroup>
                    <Label for="state">Status</Label>
                    <Select
                      id="statusID"
                      options={statusOptions}
                      defaultValue={
                        status?.find(
                          option => option.value === selectedItem?.StatusID
                        ) || ""
                      }
                      onChange={option =>
                        setFieldValue("statusID", option?.value)
                      }
                      onBlur={handleBlur("statusID")}
                      isClearable
                    />
                    {touched.statusID && errors.statusID && (
                      <div className="text-danger">{errors.statusID}</div>
                    )}
                  </FormGroup>
                }

                {!isEditMode && (
                  <FormGroup>
                    <Label for="Note">Note</Label>
                    <Input
                      type="textarea"
                      id="Note"
                      name="Note"
                      defaultValue={values.Note}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={touched.Note && !!errors.Note}
                    />
                  </FormGroup>
                )}
              {  console.log("statusID",values.statusID )
                }
                {values.statusID == "4" ? (
                  <FormGroup>
                    <Label for="comment">Comment to Client</Label>
                    <Input
                      type="textarea"
                      id="comment"
                      name="comment"
                      defaultValue={values.comment}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={touched.comment && !!errors.comment}
                    />
                    {touched.comment && errors.comment && (
                      <div className="text-danger">{errors.comment}</div>
                    )}
                  </FormGroup>
                ) : (
                  ""
                )}
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                  Cancel
                </Button>
                <Button type="submit" color="primary">
                  Submit
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  )
}

export default UpdateModal
